import {
	type LayoutNavComponentProps,
	SvgFromUrl,
	TrackingLink,
} from '@ds-mgnl/marketing';
import { classNames } from '@dsx/react';
import logoSvg from '../assets/images/aptura-logo.svg';
import styles from './ApturaLogo.module.css';

export type ApturaLogoProps = LayoutNavComponentProps;

export function ApturaLogo({ transparent }: ApturaLogoProps) {
	return (
		<TrackingLink href="/" clickType="header_link" trackingText="Top Nav Logo">
			<div className={styles['logo-container']}>
				<SvgFromUrl
					url={logoSvg}
					height={'44px'}
					className={classNames(styles['aptura-logo'], {
						[styles['transparent']]: transparent,
					})}
				/>
			</div>
		</TrackingLink>
	);
}
